export const REGISTER_REQUEST = "USER.REGISTER_REQUEST";
export const REGISTER_SUCCESS = "USER.REGISTER_SUCCESS";
export const REGISTER_FAILURE = "USER.REGISTER_FAILURE";

export const REACTION_REQUEST = "USER.REACTION_REQUEST";
export const REACTION_SUCCESS = "USER.REACTION_SUCCESS";
export const REACTION_FAILURE = "USER.REACTION_FAILURE";
